import React, { Fragment } from 'react';
import { COLORS } from 'themes';
import RaceCard from 'features/RaceCard';
import 'pure-react-carousel/dist/react-carousel.es.css';
import './carousel-styles.css';
import Wrapper from 'ui/Wrapper';
import Text from 'ui/Text';
import { connect } from 'react-redux';
import {
    keepRaceIndexInState,
    setRace,
} from 'features/AISDataProvider/actions';
import {
    getTrackBySelectedMultitrackRace,
    getTrackFromRacingCard,
} from 'common/selectors/trackSelector';
import racesSelector, {
    getDisabledRaceNumbers,
    isAnyRaceStarted,
    getFirstUpcomingRace,
    getForecastRace,
} from 'common/selectors/racesSelector';
import { isMultitrackProduct } from 'common/selectors/multipleTrackSetupsSelector';
import {
    getMultitrackLegs,
    gotEventError,
    isPending,
} from 'common/selectors/raceDaySelector';
import { betPickSelector } from 'common/selectors/betTableSelector';
import SlickSlider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { isMobile } from 'react-device-detect';
import { byPlatform, forDesktop, forMobile, omitMobile } from 'utils/platforms';
import RacingCard from 'common/DataObjects/RacingCard';
import Mark from 'ui/Mark';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import combinationsCountSelector from 'common/selectors/combinationsCountSelector';
import productSelector from 'common/selectors/productSelector';
import { getDefaultRaceDay, inputErrorReasons } from 'features/AISDataProvider';
import VRaceOverview from 'features/VRaceOverview';
import persistentStorage from 'features/PersistentStorage';
import YouthWarning from './YouthWarning';
import Forecast from 'features/Forecast';
import { RaceNavigationLabel, ScrollBar } from 'ui/RaceNavigation';
import Checkbox2 from 'ui/Checkbox2';
import RaceLine from 'features/RacesCarusel/RaceLine';
import Preloader from './Preloader';
import * as RaceNavigation from 'ui/RaceNavigation';
import { terminal } from 'configs/layout';
import RaceCardReplays from '../RaceCardReplays';
import HorseTips from 'features/HorseTips';

class RaceCarusel extends React.Component {
    rootSliderEl = null;

    constructor() {
        super();

        this.state = {
            hasError: false,
            reserveModeEnabled: false,
            showOverview:
                persistentStorage.getLS('vRaceOverviewDisabled') !== 'true',
        };
    }

    getOverviewStatus() {
        return persistentStorage.getLS('vRaceOverviewDisabled') !== 'true';
    }

    toggleOverviewStatus() {
        persistentStorage.saveLS({
            vRaceOverviewDisabled: this.state.showOverview,
        });
        this.setState({ showOverview: !this.state.showOverview });
    }

    setReserveMode = () => {
        this.setState({ reserveModeEnabled: !this.state.reserveModeEnabled });
    };

    componentDidCatch(error, info) {
        this.setState({ hasError: true });
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.selectedProduct.isStrictVProduct() &&
            !this.props.selectedProduct.isStrictVProduct()
        ) {
            this.setState({ reserveModeEnabled: false });
        }
        this.preventHorizontalScrollingTilTouchMove();
    }

    preventHorizontalScrollingTilTouchMove = () => {
        this.rootSliderEl = window.document.querySelector('.slick-slider');

        if (this.rootSliderEl) {
            this.rootSliderEl.addEventListener('touchstart', this.touchStart);
            this.rootSliderEl.addEventListener('touchmove', this.preventTouch, {
                passive: false,
            });
        }
    };

    moveCaruselToSlide = (index) => {
        if (isMobile) {
            this.slider.slickGoTo(index);
        } else {
            this.setRaceToReduxState(index);
        }
    };

    onCaruselMoved = (index) => {
        this.setRaceToReduxState(index);
    };

    setRaceToReduxState = (index) => {
        const { races } = this.props;
        this.props.setRace(races[index].raceNumber, index);
    };

    touchStart(e) {
        this.firstClientX = e.touches[0].clientX;
        this.firstClientY = e.touches[0].clientY;
    }

    preventTouch(e) {
        const minValue = 10; // threshold

        this.clientX = e.touches[0].clientX - this.firstClientX;
        this.clientY = e.touches[0].clientY - this.firstClientY;

        // Vertical scrolling does not work when you start swiping horizontally.
        if (Math.abs(this.clientX) > minValue) {
            if (e && e.preventDefault) e.preventDefault();
            e.returnValue = false;

            return false;
        }
    }

    renderRacingCard = (race, index) => {
        let {
            betPicks,
            selectedProduct,
            track,
            AISDataProvider,
            selectedBets,
            shoeInfo,
            disabledRaceNumbers,
            trioMarksIndicator,
            markTrioRow,
            unmarkTrioRow,
            addAllBets,
            addBet,
            removeBet,
            resetRaceBet,
            showStatisticPopup,
            showReplayPopup,
            isMultitrackProduct,
        } = this.props;

        if (!race) {
            return <Preloader />;
        }

        if (race.youthRace) {
            return <YouthWarning key={index} race={race} track={track} />;
        }

        return (
            <RaceCard
                key={index}
                race={race}
                index={race.index}
                setReserveMode={this.setReserveMode}
                reserveModeEnabled={this.state.reserveModeEnabled}
                selectedProduct={selectedProduct}
                selectedDate={AISDataProvider.racingCardData.date}
                trackCode={track.code}
                track={track}
                trackId={track.id}
                isMultitrack={isMultitrackProduct}
                bet={betPicks.get(race.index)}
                poolOverview={false}
                rawPool={AISDataProvider.trackPool}
                trackPoolFetched={AISDataProvider.trackPoolFetched}
                date={AISDataProvider.racingCardData.date}
                serverTime={AISDataProvider.serverTime}
                productId={AISDataProvider.selectedProduct.id}
                selectedBets={selectedBets}
                shoeInfo={shoeInfo}
                disabledRaceNumbers={disabledRaceNumbers}
                trioMarksIndicator={trioMarksIndicator}
                markTrioRow={markTrioRow}
                unmarkTrioRow={unmarkTrioRow}
                addAllBets={addAllBets}
                addBet={addBet}
                removeBet={removeBet}
                resetRaceBet={resetRaceBet}
                showStatisticPopup={showStatisticPopup}
                showReplayPopup={showReplayPopup}
            />
        );
    };

    renderVRaceOverview = (races, index) => {
        let {
            betPicks,
            selectedProduct,
            AISDataProvider,
            addBet,
            removeBet,
            selectedBets,
            resetBet,
            track,
        } = this.props;

        if (
            !this.props.selectedProduct.isStrictVProduct() ||
            !races ||
            !races[0].saleOpen ||
            !this.state.showOverview
        ) {
            return null;
        }

        return (
            <VRaceOverview
                key={'v' + index}
                races={races}
                setReserveMode={this.setReserveMode}
                reserveModeEnabled={this.state.reserveModeEnabled}
                selectedProduct={selectedProduct}
                selectedDate={AISDataProvider.racingCardData.date}
                trackCode={track.code}
                addBet={addBet}
                resetBet={resetBet}
                betPicks={betPicks}
                selectedBets={selectedBets}
                removeBet={removeBet}
            />
        );
    };

    slider = null;

    renderForMobile = (isDesktop = false) => {
        const settings = {
            vertical: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            beforeChange: (oldIndex, newIndex) =>
                setTimeout(() => this.onCaruselMoved(newIndex), 200),
            draggable: isDesktop,
            swipeToSlide: !isDesktop,
            touchThreshold: 10,
            initialSlide: this.props.raceIndex,
            lazyLoad: true,
        };

        let { races } = this.props;

        return (
            <SlickSlider
                ref={(slider) => (this.slider = slider)}
                key={this.props.raceIndex}
                {...settings}
            >
                {races.map((race, i) => this.renderRacingCard(race, i))}
            </SlickSlider>
        );
    };

    renderForDesktop = () => {
        const race = this.props.races[this.props.raceIndex];

        return (
            <Wrapper padding="0 0 20px 0" data-test-id="betting-table">
                {this.renderVRaceOverview(
                    this.props.races,
                    this.props.raceIndex
                )}
                {this.renderRacingCard(race, this.props.raceIndex)}
            </Wrapper>
        );
    };

    renderForTerminal = () => {
        const race = this.props.races[this.props.raceIndex];
        const wrapperStyles = {
            width: terminal.homepage.wrapperWidth,
            padding: '0px',
            transition: 'width 1s',
        };

        return (
            <Wrapper {...wrapperStyles}>
                {this.renderVRaceOverview(
                    this.props.races,
                    this.props.raceIndex
                )}
                {this.renderRacingCard(race, this.props.raceIndex)}
            </Wrapper>
        );
    };

    renderAccordingToPlatform = () => {
        const renderFunction = byPlatform(
            this.renderForMobile,
            this.renderForDesktop,
            this.renderForTerminal
        );

        const content =
            typeof renderFunction === 'function' ? renderFunction() : <div />;

        return content;
    };

    renderNoDataText = () => (
        <Wrapper margin="50px 0">
            <Text align="center">
                {this.props.inputErrorReason &&
                this.props.inputErrorReason ===
                    inputErrorReasons.INPUT_ERROR_TRACK
                    ? 'Løbet er ikke tilgængeligt på Derby'
                    : 'Der er ingen tilgængelige løb i øjeblikket.'}
            </Text>
        </Wrapper>
    );

    renderOverviewCheckbox = () => {
        if (this.props.anyRaceStarted) {
            return null;
        }

        const checkbox = (
            <div className="flex flex-end center-v">
                <RaceNavigationLabel style={{ color: COLORS.black }}>
                    {this.props.selectedProduct.id} oversigt
                </RaceNavigationLabel>
                <Checkbox2
                    className="flex-end"
                    id="raceOverview"
                    checked={this.getOverviewStatus()}
                    onChange={this.toggleOverviewStatus.bind(this)}
                    size={24}
                />
            </div>
        );

        return this.props.selectedProduct.isStrictVProduct()
            ? byPlatform(null, checkbox, checkbox)
            : null;
    };

    renderTopReplays = () => {
        const {
            AISDataProvider,
            track,
            selectedProduct,
            disabledRaceNumbers,
            selectedRaceIndex,
            races,
        } = this.props;

        const countryCode = AISDataProvider.selectedRaceDay.country.code;

        return (
            <RaceCardReplays
                date={AISDataProvider.racingCardData.date}
                disabledRaceNumbers={disabledRaceNumbers}
                track={track}
                product={selectedProduct}
                selectedRaceIndex={selectedRaceIndex}
                races={races}
                countryCode={countryCode}
            />
        );
    };

    render() {
        const { hasError } = this.state;

        if (hasError) {
            return (
                <Wrapper>
                    <Mark grey>Could not display the races.</Mark>
                </Wrapper>
            );
        }

        const {
            racingCardPending,
            racingCardFetched,
            selectedRaceDay,
        } = this.props.AISDataProvider;

        const {
            selectedProduct,
            disabledRaceNumbers,
            races,
            racingCardData,
            isMultitrackProduct,
        } = this.props;

        const raceLineItems = races.map((race, index) => {
            return selectedProduct.isVProduct()
                ? index + 1
                : race.uiNumber || race.raceNumber;
        });

        if (this.props.isPending) {
            return <Preloader />;
        }

        if (
            !racingCardData.isNull() &&
            racingCardFetched &&
            !racingCardPending &&
            races.length
        ) {
            const gridTemplateColumns = selectedProduct.isVProduct()
                ? '90px 3fr 2fr' // reserving some space for V overview checkbox
                : '90px 1fr';

            return (
                <Fragment>
                    <Wrapper
                        position="relative"
                        display={omitMobile('grid')}
                        style={byPlatform(
                            {},
                            { gridTemplateColumns },
                            {
                                gridTemplateColumns,
                                width: byPlatform(
                                    terminal.homepage.wrapperWidth,
                                    terminal.homepage.wrapperWidth,
                                    `calc(${
                                        terminal.homepage.wrapperWidthWithMargin
                                    } - 10px)`
                                ),
                            }
                        )}
                        padding={byPlatform(
                            '30px 0 10px',
                            '30px 25px 10px 25px'
                        )}
                        data-test-id="races"
                    >
                        {omitMobile(
                            <RaceNavigationLabel>Løb/afd.</RaceNavigationLabel>
                        )}
                        <ScrollBar
                            style={{ display: 'flex', alignItems: 'center' }}
                        >
                            <RaceLine
                                raceNumbers={raceLineItems}
                                setRaceIndex={this.setRaceToReduxState}
                                raceIndex={this.props.raceIndex}
                                fadedRaceNumbers={disabledRaceNumbers}
                            />
                            {/* fixes Mob. Padding after the last button DER-2629 (padding-right doesn't work for mobile) */}
                            {forMobile(<RaceNavigation.ScrollbarRightIndent />)}
                        </ScrollBar>
                        {this.renderOverviewCheckbox()}
                    </Wrapper>
                    {!selectedProduct.isVProduct() &&
                        selectedRaceDay.hasAnyResult &&
                        this.renderTopReplays()}
                    <Wrapper
                        padding="0px"
                        margin="20px"
                        rounded="10"
                        width={byPlatform(null, null, 'calc(100% - 440px)')}
                    >
                        <Forecast
                            product={this.props.selectedProduct}
                            ongoingRace={this.props.forecastRace}
                        />
                    </Wrapper>

                    {this.renderAccordingToPlatform()}

                    {!isMultitrackProduct && (
                        <Wrapper padding="0 20px 20px">
                            <HorseTips
                                raceIndex={this.props.raceIndex}
                                race={races[this.props.raceIndex]}
                            />
                        </Wrapper>
                    )}
                </Fragment>
            );
        }

        if (this.props.gotEventError) {
            return this.renderNoDataText();
        }

        return <Preloader />;
    }
}

const mapStateToProps = (state) => ({
    track: getTrackFromRacingCard(state),
    // Warning! Don't extract trackName from state using
    // getTrackFromRacingCard or getTrackByIdentity selectors
    // Sometimes different track names belong to the same track.
    trackFromRacingCard: state.AISDataProvider?.selectedRaceDay?.track,
    multitrack: getTrackBySelectedMultitrackRace(state),
    races: racesSelector(state),
    forecastRace: getForecastRace(state),
    isMultitrackProduct: isMultitrackProduct(state),
    tracksByCode: state.AISDataProvider.tracks
        ? state.AISDataProvider.tracks.byCode
        : {},
    multitrackLegs: getMultitrackLegs(state),
    selectedRaceNumber: state.AISDataProvider.selectedRaceNumber,
    AISDataProvider: state.AISDataProvider,
    racingCardData: RacingCard.fill(state.AISDataProvider),
    betPicks: betPickSelector(state),
    selectedRaceIndex: state.AISDataProvider.raceIndex,
    firstUpcomingRace: getFirstUpcomingRace(state),
    combinationsCount: combinationsCountSelector(state),
    selectedProduct: productSelector(state),
    disabledRaceNumbers: getDisabledRaceNumbers(state),
    defaultRaceDay: getDefaultRaceDay(state.AISDataProvider.raceDayData),
    inputErrorReason: state.AISDataProvider.inputErrorReason,
    anyRaceStarted: isAnyRaceStarted(state),
    gotEventError: gotEventError(state),
    isPending: isPending(state),
});

const mapDispatchToProps = (dispatch) => {
    return {
        setRace: (raceNumber, raceIndex) => {
            dispatch(setRace(raceNumber, raceIndex));
        },
        keepRaceNumberInState: (raceNumber) => {
            dispatch(keepRaceIndexInState(raceNumber));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RaceCarusel);

export { RaceCarusel };
